import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    readonly currentUserState = signal<any>(null);
    readonly currentUser: Observable<any> = toObservable(this.currentUserState);
    isRefreshingToken: boolean;

    constructor() {
        let storedUser: any = localStorage.getItem('currentUser');
        if (storedUser) {
            storedUser = JSON.parse(storedUser);
        }
        this.currentUserState.set(storedUser);
        this.isRefreshingToken = false;
        this.checkCurrentUser();
    }

    checkCurrentUser() {
        const storedUser = localStorage.getItem('currentUser');
        if (!storedUser && this.currentUserState()) {
            // empty if


        }
    }

    public get currentUserValue(): any {
        return this.currentUserState();
    }

    isLoggedIn(): Observable<boolean> {
        return this.currentUser;
    }

    login(result: string) {
        localStorage.setItem('currentUser', JSON.stringify(result));
        this.currentUserState.set(result);
        return result;
    }

    changeAccessToken() {
        const user = this.currentUserState();
        console.log(user.access_token);
        user.access_token = user.access_token + 'fsdfsdf';
        console.log(user);
        this.currentUserState.set({ ...user });
    }

}